module.exports = __webpack_public_path__ + "img/sitting-pose.4c1e2a04.svg";